// extracted by mini-css-extract-plugin
module.exports = {"error-hero-container":"Error_error-hero-container__GjRae","main":"Error_main__dpGtB","icon-container":"Error_icon-container___ZF6b"};